module.exports = new __parcel__URL__("kangaroo.099f9dd4.svg").toString();